import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { _ } from '../../../functions/translator.js';
import { bindActionCreators } from 'redux';
import { ToggleActions } from '../../../constants/constants.js';
import { popUpMenuChange,
        selectedCardsGroupsChange,
        toggleSwitch } from '../../../actions/index';

import { LuSquareSplitHorizontal } from "react-icons/lu";


function TunnelSubdivisionsButton(props){

    const handleClick = () => {
        props.toggleSwitch(ToggleActions.TUNNEL_SUBDIVISION);
        props.popUpMenuChange({ show: false });
    };

    return(
        <div className="popup-menu-button card-color" onClick={handleClick}>
            <div className='w-100'>
                <div className='d-inline-flex'>
                    <div className='d-flex align-items-center mr-2 ml-3'>
                        <LuSquareSplitHorizontal size={30} />
                    </div>
                    <p>{ _('Subdividir Túnel') }</p>
                </div>
            </div>
        </div>
        
    )
}

function mapStateToProps(state) {
    return {
        popUpMenu: state.popUpMenu,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        popUpMenuChange: popUpMenuChange,
        toggleSwitch: toggleSwitch,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(TunnelSubdivisionsButton);